const postForgotPasswordPayload = (data) => {
  return {
    email: data?.email,
  };
};

export default postForgotPasswordPayload;
